module.exports = __webpack_public_path__ + "img/calendar.ef5361b1.svg";